import { gql, TypedDocumentNode } from '@apollo/client';
import { Batch, ProcessedBatchesResult } from '../models/Batch';

export const GET_BATCHES_QUERY: TypedDocumentNode<{ batches: Batch[] }, { filter?: {} }> = gql`
  query GetBatches($filter: BatchFilterInput) {
    batches(where: $filter, order: [{ product: { name: ASC }}]) {
      id,
      dateTimeCreated,
      productId,
      product {
        id,
        name,
        customerId,
        customer {
          id,
          name
        }
      },
      amount,
      lotNumber,
      isComplete,
      notes,
      totalCost,
      calculatedProductItems {
        id,
        itemId,
        item {
          id,
          name
        },
        productId,
        quantity,
        productBatchQuantity,
        remainingProductBatchQuantity,
        productBatchQuantityMet,
        notes,
        calculatedItemCost,
        calculatedConsumedInventoryItems {
          id,
          inventoryItemId,
          inventoryItem {
            id,
            lotNumber,
            quantityOnHand,
            totalCostPerUnit,
            vendorId,
            vendor {
              id,
              name
            },
            purchaseOrder {
              dateTimePurchased
            },
            remainingQuantityOnHand
          },
          quantityNeeded,
          quantityUsed,
          totalProductBatchQuantity,
          totalItemCost
        }
      },
      consumedInventoryItems {
        id,
        inventoryItemId,
        inventoryItem {
          id,
          purchaseOrderId,
          purchaseOrder {
            id,
            dateTimePurchased
          },
          itemId,
          item {
            id,
            name
          },
          vendorId,
          vendor {
            id,
            name
          },
          lotNumber
        },
        quantityNeeded,
        quantityUsed,
        totalProductBatchQuantity,
        totalItemCost
      }
    }
  }
`;

export const GET_BATCH_BY_ID_QUERY: TypedDocumentNode<{ batch: Batch }, { id: number }> = gql`
  query GetBatchById($id: Int!) {
    batch: batchById(id: $id) {
      id,
      dateTimeCreated,
      productId,
      product {
        id,
        name,
        customerId,
        customer {
          id,
          name
        }
      },
      amount,
      lotNumber,
      isComplete,
      notes,
      totalCost,
      calculatedProductItems {
        id,
        itemId,
        item {
          id,
          name
        },
        productId,
        quantity,
        productBatchQuantity,
        remainingProductBatchQuantity,
        productBatchQuantityMet,
        notes,
        calculatedItemCost,
        calculatedConsumedInventoryItems {
          id,
          inventoryItemId,
          inventoryItem {
            id,
            lotNumber,
            quantityOnHand,
            totalCostPerUnit,
            vendorId,
            vendor {
              id,
              name
            },
            purchaseOrder {
              dateTimePurchased
            },
            remainingQuantityOnHand
          },
          quantityNeeded,
          quantityUsed,
          totalProductBatchQuantity,
          totalItemCost
        }
      },
      consumedInventoryItems {
        id,
        inventoryItemId,
        inventoryItem {
          id,
          purchaseOrderId,
          purchaseOrder {
            id,
            dateTimePurchased
          },
          itemId,
          item {
            id,
            name
          },
          vendorId,
          vendor {
            id,
            name
          },
          lotNumber
        },
        quantityNeeded,
        quantityUsed,
        totalProductBatchQuantity,
        totalItemCost
      }
    }
  }
`;

export const GET_PROCESS_BATCHES_RESULT_QUERY: TypedDocumentNode<{ processedBatchesResult: ProcessedBatchesResult }, { ids: number[] }> = gql`
  query getProcessBatchesResult($ids: [Int!]!) {
    processedBatchesResult: processBatchesResult(ids: $ids) {
      combinedCalculatedItemResults {
        item {
          id,
          name,
          inventoryItems {
            id,
            lotNumber,
            quantityOnHand,
            quantityOrdered,
            dateOrdered,
            vendor {
              name
            }
          }
        },
        totalQuantity,
        totalQuantityOnHand,
        totalRemainingQuantityOnHand
      },
      batches {
        id,
        dateTimeCreated,
        productId,
        product {
          id,
          name,
          customerId,
          customer {
            id,
            name
          }
        },
        amount,
        lotNumber,
        isComplete,
        notes,
        totalCost,
        calculatedProductItems {
          id,
          itemId,
          item {
            id,
            name
          },
          productId,
          quantity,
          productBatchQuantity,
          remainingProductBatchQuantity,
          productBatchQuantityMet,
          notes,
          calculatedConsumedInventoryItems {
            id,
            inventoryItemId,
            inventoryItem {
              id,
              lotNumber,
              quantityOnHand,
              vendorId,
              vendor {
                id,
                name
              },
              purchaseOrder {
                dateTimePurchased
              },
              remainingQuantityOnHand 
            },
            quantityNeeded,
            quantityUsed,
            totalProductBatchQuantity,
            totalItemCost
          }
        },
        consumedInventoryItems {
          id,
          inventoryItemId,
          inventoryItem {
            id,
            purchaseOrderId,
            purchaseOrder {
              id,
              dateTimePurchased
            },
            itemId,
            item {
              id,
              name
            },
            vendorId,
            vendor {
              id,
              name
            },
            lotNumber
          },
          quantityNeeded,
          quantityUsed,
          totalProductBatchQuantity,
          totalItemCost
        }
      }
    }
  }
`;
